import { format, formatDistanceToNow } from "date-fns"
import { useState } from "react"
import { Button } from "~/components/ui/button"
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger
} from "~/components/ui/tooltip"
import { cn } from "~/lib/utils"

export function RelativeTimestamp({
	date,
	formatRelativeTimestamp,
	className,
	label
}: {
	date: Date
	formatRelativeTimestamp?: (date: Date) => string
	className?: string
	label?: string
}) {
	const [open, setOpen] = useState(false)
	const exact = format(date, "d MMM yyyy, HH:mm O")
	const relative =
		formatRelativeTimestamp?.(date) ??
		(Date.now() - date.getTime() < 365 * 24 * 60 * 60 * 1000
			? formatDistanceToNow(date, { addSuffix: true })
			: exact)
	return (
		<Tooltip open={open} onOpenChange={setOpen}>
			<TooltipTrigger asChild>
				<Button
					variant="none"
					size="none"
					aria-label={label ? `${label} ${relative}` : undefined}
					onClick={(event) => {
						event.preventDefault()
						setOpen((open) => !open)
					}}
					className={cn(
						"shrink-0 cursor-help text-text-small text-xs decoration-dashed transition hover:decoration-solid",
						className
					)}
				>
					<time dateTime={date.toISOString()}>{relative}</time>
				</Button>
			</TooltipTrigger>
			<TooltipContent>{label ? `${label}: ${exact}` : exact}</TooltipContent>
		</Tooltip>
	)
}
